import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import FooterLink from "./components/FooterLink";

import { Link, useLocation } from "react-router-dom";
import { adminPath, teachersubadminPath } from "../../services/defaultSettings";
import CenterIcon from "../../components/ui/CenterIcon";
import footerLogo from "../../assets/komet-assets/footerLogoWhite.png";
import { ReactComponent as Facebook } from "../../assets/komet-assets/facebookIcon.svg";
import { ReactComponent as Instagram } from "../../assets/komet-assets/instaIcon.svg";
import { ReactComponent as Twitter } from "../../assets/komet-assets/twitterIcon.svg";

const Footer = () => {
    const location = useLocation();
    const links = [
        { name: "home", to: "/" },
        { name: "About us", to: "/about_us" },
        { name: "FAQ", to: "/faq" },
        { name: "Team", to: "/team" },
        { name: "Career", to: "/join_us" },
    ];
    const Categorieslinks = [
        { name: "Regular Courses", to: "/subject/1" },
        { name: "Intensive Courses", to: "/subject/2" },
        { name: "Super intentsive Courses", to: "/subject/3" },
        { name: "Flash Courses", to: "/subject/4" },
    ];
    const socialLinks = [
        {
            name: "Facebook",
            to: "https://www.facebook.com/kometinstitut",
            icon: <Facebook className="w-12 h-12" />,
        },
        {
            name: "Instagram",
            to: "https://www.instagram.com/kometinstitut/",
            icon: <Instagram className="w-12 h-12" />,
        },
        {
            name: "Twiiter",
            to: "https://x.com/kometinstitut",
            icon: <Twitter className="w-12 h-12" />,
        },
    ];

    const renderBranches = () => {
        return (
            <ul className={`flex px-3 md:px-10 text-left flex-col gap-3  text-2xl `}>
                <div className="flex flex-col gap-5">
                    <div>
                        <h3 className="text-base font-semibold text-germanRed-300">Tanta Branch</h3>
                        <div className="h-1 w-14 bg-germanRed-600 " />

                        <div className="flex text-sm items-start gap-3 mt-2">
                            <Icon icon="mdi:map-marker" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">
                                47 Gaish Road, Above United Bank, Tanta, Egypt
                            </p>
                        </div>
                        <div className="flex items-start text-sm gap-3 mt-2">
                            <Icon icon="mdi:phone" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">040 3321924</p>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-base font-semibold text-germanRed-300">
                            Alexandria Branches:
                        </h3>
                        <div className="h-1 w-14 bg-germanRed-600 " />

                        <div className="flex text-sm items-start gap-3 mt-2">
                            <Icon icon="mdi:map-marker" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">277 - St. AbdulAziz Fahmy, Stanley</p>
                        </div>
                        <div className="flex text-sm items-start gap-3 mt-2">
                            <Icon icon="mdi:phone" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">03 5413722 - 03 5469786</p>
                        </div>
                        <div className="flex text-sm items-start gap-3 mt-2">
                            <Icon icon="mdi:map-marker" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">52 - St. El Hadaya Mosque, Stanley</p>
                        </div>
                        <div className="flex text-sm items-start gap-3 mt-2">
                            <Icon icon="mdi:phone" className="text-germanRed-300 w-4 h-4" />
                            <p className="text-gray-200">03 5448431 - 03 5448432</p>
                        </div>
                    </div>
                </div>
            </ul>
        );
    };
    // function topFunction() {
    //     document.body.scrollTop = 0; // For Safari
    //     document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    // }
    const [className, setClassName] = useState("");

    useEffect(() => {
        if (
            location.pathname.includes(adminPath) ||
            location.pathname.includes(teachersubadminPath)
        ) {
            setClassName(" !hidden");
        } else {
            setClassName("");
        }
    }, [location.pathname]);
    return (
        <div className={`z-50  h-full en ${className}`}>
            <footer className="relative z-50 font-ibm-arabic clr-white h-full py-20 w-[95%] mx-auto rounded-xl overflow-hidden bg-germanAccentText clr-primary-text smooth">
                <div className="flex justify-between px-0 md:px-20 flex-col w-full sm:flex-row gap-6">
                    <div className=" flex justify-center ">
                        <div className="flex justify-center items-center flex-col opacity-100 ">
                            <div className="w-[50%] sm:w-[200px] ">
                                <img src={footerLogo} alt="footer logo" />
                            </div>
                            <div className="flex items-center justify-evenly gap-5">
                                {socialLinks.map((social, index) => (
                                    <li
                                        key={index}
                                        className=" smooth flex mt-8 items-center gap-8 font-normal text-lg"
                                    >
                                        <a
                                            href={social.to}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="w-6 h-6 flex items-center justify-center transition-colors"
                                        >
                                            {social.icon}
                                        </a>
                                    </li>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="links flex flex-col md:flex-row flex-wrap px-2 text-center md:text-left justify-evenly items-center md:items-start gap-5 md:gap-4 w-full mt-10 sm:mt-0  ">
                        <ul className="flex flex-col gap-1 md:gap-3  text-2xl ">
                            <p className=" text-left font-medium smooth">Komet Institut</p>
                            <div className="h-1 w-1/3 bg-germanRed-600 -mt-2" />

                            {links.map((link, index) => (
                                <li
                                    className=" smooth font-normal text-base text-gray-400 hover:text-germanRed-200 smooth"
                                    key={index}
                                >
                                    <Link to={link.to}>{link.name}</Link>
                                </li>
                            ))}
                        </ul>
                        <ul className="flex flex-col gap-1 md:gap-3  text-2xl ">
                            <p className="text-left font-medium  smooth">Categories</p>
                            <div className="h-1 w-1/3 bg-germanRed-600 -mt-2" />
                            {Categorieslinks.map((link, index) => (
                                <li
                                    className=" smooth font-normal text-base text-gray-400 hover:text-germanRed-200 smooth"
                                    key={index}
                                >
                                    <Link to={link.to}>{link.name}</Link>
                                </li>
                            ))}
                        </ul>
                        {renderBranches()}
                    </div>
                </div>
            </footer>
            <div className="bg-alphaAccentText dark:bg-alphaAccentText/30 smooth">
                <p className="text-center py-3 text-alphaBlackText dark:text-alphaAccentText smooth text-md">
                    <div className="en text-center font-ibm-arabic space-x-2 opacity-100 px-5 flex flex-wrap flex-center-both">
                        <span className="space-x-1">
                            <span>&#60;</span>
                            <span>Developed By</span>
                            <span>&#62;</span>
                        </span>
                        <span>
                            <a
                                href="https://www.facebook.com/Om4rS4Ieh/"
                                className=" hover-shadow text-germanRed-700  px-2 py-2 rounded-md"
                            >
                                Omar
                            </a>
                            <span>,</span>
                            <a
                                href="https://www.facebook.com/emad.sharf.16"
                                className=" hover-shadow  text-germanRed-700 px-3 py-1 rounded-md"
                            >
                                Emad
                            </a>
                        </span>
                        <span className="space-x-1">
                            <span className="">&#60;</span>
                            <span className="">
                                All Copy Rights Reserved @{new Date().getFullYear()}
                            </span>
                            <span className="">&#62;</span>
                        </span>
                    </div>{" "}
                </p>
            </div>
        </div>
    );
};

export default Footer;
